import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AlertErrorText from '../../../components/Alert/AlertErrorText';
import AlertSuccessText from '../../../components/Alert/AlertSuccessText';
import { dodajKatalog } from '../../../dao/Katalog';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));
export default function KatalogDodaj(props) {
  const [open, setOpen] = useState(false);
  const [katalog, setKatalog] = useState(null);
  const classes = useStyles();
  const katalog_skrot = useRef(null);
  const katalog_nazwa = useRef(null);
  const handleClickKDOpen = () => {
    setKatalog(props.biRef.getSelected());
    setOpen(true);
  };
  let biRefErrorInfo = {
  };
  let biRefSuccessInfo = {
  };
  const handleDodaj = () => {
    dodajKatalogF();
  };
  async function dodajKatalogF() {
    let id_kat="";
    if (!katalog) {
      id_kat = "";
    } else {
      id_kat = katalog.id_kat;
    }
    console.log(" dodajKatalog id_kat " + id_kat);

    let x = await dodajKatalog(id_kat, katalog_skrot.current.value, katalog_nazwa.current.value).catch(e => {
      biRefErrorInfo.pokazText(e.message);
      return null;
    });
    console.log("dodajKatalog " + (new Date()).toLocaleTimeString());
    if (!x) {
      console.log("błąd");
    } else {
      if (x.error) {
        biRefErrorInfo.pokazText(x.error.info);
        return;
      }
      biRefSuccessInfo.pokazText("Dodany");
      window.setTimeout(() => {
        setOpen(false);
        //  props.biRef.handleClose();
      }, 2000);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button variant="outlined" color="primary" onClick={handleClickKDOpen} style={{ textAlign: 'left' }}>
        Dodaj katalog
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Dodaj katalogu</DialogTitle>
        <DialogContent>
          Dodajesz do katalog: <strong>{(katalog) && katalog.nazwa}</strong>
          <br />skrót: <strong>{(katalog) && katalog.id_kat}</strong>
          <form className={classes.root} noValidate autoComplete="off">
            <TextField inputRef={katalog_skrot} label="Katalog skrót" />
            <TextField inputRef={katalog_nazwa} label="Katalog nazwa" />
          </form>
          <AlertErrorText biRef={biRefErrorInfo} />
          <AlertSuccessText biRef={biRefSuccessInfo} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Anuluj
          </Button>
          <Button onClick={handleDodaj} color="primary">
            Dodaj
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}